<template>
  <Fragment>
    <svg :class="`icon icon--${name}`"><use :href="`#icon-${name}`"></use></svg>
    <span class="sr-only" v-if="label">{{ label }}</span>
  </Fragment>
</template>

<script>
export default {
  name: 'Icon',
  props: {
    name: {
      type: String,
      required: true,
    },
    label: String,
  },
};
</script>

<style lang="scss">
.icon {
  display: inline-block;
  width: 1em;
  height: 1em;
  stroke-width: 0;
  stroke: currentColor;
  fill: currentColor;

  &--success {
    color: var(--g-color-success);
  }

  &--error {
    color: var(--g-color-error);
  }
}

.icon--line-chart {
  width: 1.15em;
}

.icon--pencil {
  width: 0.85em;
}

.icon--link {
  width: 0.93em;
}

.icon--plus {
  width: 0.79em;
}

.icon--question-circle-o {
  width: 0.89em;
}

.icon--smile-o {
  width: 0.86em;
}

.icon--ellipsis-h {
  width: 0.7857em;
}

.icon--lock {
  width: 0.642857em;
}

.icon--repeat {
  width: 0.8571428em;
}

.icon--refresh {
  width: 0.857142em;
}

.icon--file-pdf-o {
  width: 0.85714em;
}

.icon--upload {
  width: 0.928571em;
}

.icon--tag {
  width: 0.845428em;
}

.icon--google {
  width: 0.83985em;
}

.icon--google-sheet {
  width: 0.857142em;
}

.icon--folder-o {
  width: 0.928571em;
}

.icon--code {
  width: 1.071428em;
}

.icon--star {
  width: 0.9285em;
}

.icon--star-o {
  width: 0.92857em;
}

.icon--chevron-left {
  width: 0.75em;
}

.icon--chevron-right {
  width: 0.678571em;
}

.icon--qr-code {
  width: 0.785714em;
}
</style>
